<div class="flex flex-col gap-1" data-test-class="filter-group">
	<span class="font-semibold">
		{{ 'compositions.filters.type.' + title() | translate }}
	</span>
	<div class="flex flex-col gap-3">
		@for (filterItem of visibleItems(); track filterItem.value) {
			<div class="flex flex-row">
				<vp-checkbox
					[initialValue]="activeValues().includes(filterItem.value)"
					[inputId]="filterItem.value"
					(emittedValue)="onToggle(filterItem.value, $event)"
					class="w-full"
				>
					{{ filterItem.name }}
				</vp-checkbox>
				<span>{{ filterItem.frequency }}</span>
			</div>
		}
		@if (hasMoreItems()) {
			<button
				(click)="showMore()"
				class="w-fit underline"
				data-test-class="show-more"
			>
				{{ 'global.show-more' | translate }}
			</button>
		}
	</div>
</div>
